import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchProducts, showProduct } from '../../actions/product';
import * as uri from '../../config/uri';
import { setProduct } from '../../actions/product';
import { fetchByCategory, setCurrentCategoryIndex, setActiveCategoryIndex } from '../../actions/api';

import ProductContainerRender from "../ProductContainerRender/ProductContainerRender";
import { getProducts } from '../../selectors/product_selector';
import { getCategories } from '../../selectors/configSelectors';
import { pushWithQueryParams } from '../../services/uri';

class ProductContainer extends Component {
  getCategoryParam = () => {
      return this.props.match.params.category;
  }
 
  componentDidMount() {
    const path = this.props.router.location.pathname;
    let catName = path.substr(path.lastIndexOf('/'));
    if (catName === '/search') {
      if (catName === '/search' && this.props.products.data.length === 0) this.props.go(uri.rootPageUri + 'category/flower');
      return;
    }
  }

  render() {
    return <ProductContainerRender/>;
  }
}

const mapStateToProps = (state) => {
  return {
    router : state.router,
    products: getProducts(state),
    categories: getCategories(state),
    view: state.view,
  };
};

const mapDispatchToProps = (dispatch) => {
  return { 
      fetchByCategory: (name)=> dispatch(fetchByCategory(name, 0, 20)),
      setCurrentCatIdx: (idx) => dispatch(setCurrentCategoryIndex(idx)),
      go: (path) => dispatch(pushWithQueryParams(path)),
      showProduct: (index) => dispatch(showProduct(index)),
      fetchProducts: () => dispatch(fetchProducts()),
      setCurrentProduct: (product) => dispatch(setProduct(product)),
      setActiveCatIdx: (idx) => dispatch(setActiveCategoryIndex(idx)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductContainerRender);



// WEBPACK FOOTER //
// ./src/components/ProductContainerFilter/ProductContainerFilter.jsx